var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.252,
    height: 28.81,
    viewBox: "0 0 27.252 28.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grid",
    d: "M1,4.033A2.953,2.953,0,0,1,3.866,1H9.6a2.953,2.953,0,0,1,2.866,3.033V10.1A2.953,2.953,0,0,1,9.6,13.133H3.866A2.953,2.953,0,0,1,1,10.1ZM3.866,3.022a.984.984,0,0,0-.955,1.011V10.1a.984.984,0,0,0,.955,1.011H9.6a.984.984,0,0,0,.955-1.011V4.033A.984.984,0,0,0,9.6,3.022ZM16.287,4.033A2.953,2.953,0,0,1,19.153,1h5.733a2.953,2.953,0,0,1,2.866,3.033V10.1a2.953,2.953,0,0,1-2.866,3.033H19.153A2.953,2.953,0,0,1,16.287,10.1Zm2.866-1.011A.984.984,0,0,0,18.2,4.033V10.1a.984.984,0,0,0,.955,1.011h5.733a.984.984,0,0,0,.955-1.011V4.033a.984.984,0,0,0-.955-1.011ZM1,20.21a2.953,2.953,0,0,1,2.866-3.033H9.6a2.953,2.953,0,0,1,2.866,3.033v6.066A2.953,2.953,0,0,1,9.6,29.31H3.866A2.953,2.953,0,0,1,1,26.277ZM3.866,19.2a.984.984,0,0,0-.955,1.011v6.066a.984.984,0,0,0,.955,1.011H9.6a.984.984,0,0,0,.955-1.011V20.21A.984.984,0,0,0,9.6,19.2ZM16.287,20.21a2.953,2.953,0,0,1,2.866-3.033h5.733a2.953,2.953,0,0,1,2.866,3.033v6.066a2.953,2.953,0,0,1-2.866,3.033H19.153a2.953,2.953,0,0,1-2.866-3.033ZM19.153,19.2A.984.984,0,0,0,18.2,20.21v6.066a.984.984,0,0,0,.955,1.011h5.733a.984.984,0,0,0,.955-1.011V20.21a.984.984,0,0,0-.955-1.011Z",
    transform: "translate(-0.75 -0.75)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.477eb781470890b4a9b79a258d0041cc.svg";
export { ForwardRef as ReactComponent };